import type {
  PhysicalCountSessionSummary,
  PhysicalCountUploadPreviewSummary,
} from '../../../types/physicalCount.types';

export type PhysicalCountMetricKey =
  | 'expected'
  | 'scanned'
  | 'ok'
  | 'missing'
  | 'excess'
  | 'duplicate'
  | 'notAvailable';

export interface PhysicalCountMetricDefinition {
  key: PhysicalCountMetricKey;
  panelLabel: string;
  detailLabel: string;
  tooltip: string;
  getPreviewValue: (summary: PhysicalCountUploadPreviewSummary) => number;
  getSessionValue: (summary: PhysicalCountSessionSummary) => number;
}

export const PHYSICAL_COUNT_METRICS: PhysicalCountMetricDefinition[] = [
  {
    key: 'expected',
    panelLabel: 'Ítems esperados',
    detailLabel: 'Esperado',
    tooltip: 'Piezas disponibles en inventario de la sucursal.',
    getPreviewValue: (s) => s.expectedCount,
    getSessionValue: (s) => s.expectedCount,
  },
  {
    key: 'scanned',
    panelLabel: 'Códigos cargados',
    detailLabel: 'Escaneado',
    tooltip: 'Total de códigos del archivo (incluye duplicados).',
    getPreviewValue: (s) => s.scannedCount,
    getSessionValue: (s) => s.actualCount,
  },
  {
    key: 'ok',
    panelLabel: 'Coincidencias (OK)',
    detailLabel: 'Coincidencias',
    tooltip: 'Escaneados y coinciden con inventario disponible.',
    getPreviewValue: (s) => s.successCount,
    getSessionValue: (s) => s.okCount,
  },
  {
    key: 'missing',
    panelLabel: 'Faltantes',
    detailLabel: 'Faltantes',
    tooltip: 'Esperados en inventario pero no escaneados.',
    getPreviewValue: (s) => s.missingCount,
    getSessionValue: (s) => s.missingCount,
  },
  {
    key: 'excess',
    panelLabel: 'Sobrantes',
    detailLabel: 'Sobrantes',
    tooltip: 'Escaneados que no están en esta sucursal.',
    getPreviewValue: (s) => s.excessCount,
    getSessionValue: (s) => s.surplusCount,
  },
  {
    key: 'duplicate',
    panelLabel: 'Duplicados',
    detailLabel: 'Duplicados',
    tooltip: 'Mismo código repetido en el archivo.',
    getPreviewValue: (s) => s.duplicateCount,
    getSessionValue: (s) => s.duplicateCount,
  },
  {
    key: 'notAvailable',
    panelLabel: 'No disponibles',
    detailLabel: 'No disponibles',
    tooltip: 'Existen en inventario pero no están disponibles.',
    getPreviewValue: (s) => s.notAvailableCount,
    getSessionValue: (s) => s.scannedNotAvailableCount ?? 0,
  },
];
